
import Vue from "vue";

const state = {
}

const getters = {
}

const actions = {
    async getFile({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios({
                url: params.url,
                method: 'GET',
                responseType: 'blob', 
                }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.image_file_name);
                document.body.appendChild(link);
                link.click();
                var result = {};
                resolve(result);
            })
            .catch(error => reject(error));
        });
    }, 
    async getFileNotDownload({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios({
                url: params.url,
                method: 'GET',
                responseType: 'blob', 
            }).then((response) => {
                resolve(response.data);
            })
            .catch(error => reject(error));
        });
    }, 
    async getTempPublicUrl({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/files/temp-public-url`, {params:params})
            .then(response => {
                resolve( response.data );
            })
            .catch(error => reject( error ));
        });
    },     
    
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}